import styled from "@emotion/styled";

const MapBody = styled.div`
  display: flex;
  flex: 1;
`;

export default MapBody